import { createSlice } from "@reduxjs/toolkit";

const selectColorSlice = createSlice({
    name: "selectColor",
    initialState: {
        selectColor: '',
    },
    reducers: {
        setColorId: (state, action) => {
            state.selectColor = action.payload;
        },
        clearColor: (state) => {
            state.selectColor = ''; // Reset the selected color
        },
    },
});

export const { setColorId , clearColor } = selectColorSlice.actions;
export default selectColorSlice.reducer;
